import script from "./VehicleRejectDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleRejectDialog.vue?vue&type=script&setup=true&lang=js"

import "./VehicleRejectDialog.vue?vue&type=style&index=0&id=6d17d8eb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d17d8eb"]])

export default __exports__